import { CreateProjectSeriesDocument } from '@/generated/graphql';
import { useMutation } from '@vue/apollo-composable';
import { Ref, toValue } from 'vue';
import { ProjectSeriesCreateSchemaType } from '../schemas';

export function useProjectSeriesCreate(data: Ref<ProjectSeriesCreateSchemaType>) {
    const createProjectSeries = useMutation(CreateProjectSeriesDocument);

    async function create() {
        const res = await createProjectSeries.mutate({
            ...toValue(data),
        });
        const { id } = res?.data?.createProjectSeries?.projectSeries ?? {};
        if (id) {
            return { id, errors: [] };
        }
        return { id: undefined, errors: res?.errors };
    }

    return {
        create,
    };
}
